import styled from 'styled-components';

import { fontStyle } from '@savgroup-front-common/core/theme/helpers/fontStyle';

export const $Link = styled.a`
  color: ${({ theme }) => theme.colors.mainTextColor};
  font-weight: bold;
  ${fontStyle('base')};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;
